import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Grid } from '@material-ui/core';
import CodeFormField from '../../../../@common/Inputs/FormField';

const TransferMastercodeForm: FC = () => {
  const { t } = useTranslation('Order');

  return (
    <Container maxWidth="sm">
      <Grid item xs={12} sm={12}>
        <Box marginTop={2.5}>
          <CodeFormField name="firstName" label={t('First Name')} />
          <CodeFormField name="lastName" label={t('Last Name')} />
          <CodeFormField name="email" label={t('E-mail')} />
          <CodeFormField name="confirmationEmail" label={t('Confirm E-mail')} />
        </Box>
      </Grid>
    </Container>
  );
};

export default TransferMastercodeForm;
